import {passwordHint} from "@/js/accounts/utils/helpers.js";
import {API} from "@/js/accounts/utils/api.js";
import A11yDialog from 'a11y-dialog'
console.log("Profile file added");
export default () => ({
    myAccountProfileFormInit() {
          console.log("Profile App mounted");
        // Initialize form fields with existing user data if available
        // Initialise form fields with existing user data if available
        this.prefix = window.accountDetails.prefix
        this.firstname = window.accountDetails.first_name
        this.lastname = window.accountDetails.last_name
        this.currentEmail = window.accountDetails.email


        this.csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    },
    csrfToken: '',
    prefix: "-1",
    firstname: '',
    lastname: '',
    primaryEmail: '',
    currentEmail: '',
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
    errors: {},
    changeEmailDialog: null,
    triggerChangeEmailModal() {
        console.log("triggerChangeEmailModal called");
        const changeEmailModal = document.getElementById('change-email-modal');

        if (!this.changeEmailDialog) {
            this.changeEmailDialog = new A11yDialog(changeEmailModal);

            this.changeEmailDialog.on('show', () => {
                const scrollY = window.scrollY || document.documentElement.scrollTop;
                document.body.style.setProperty('--scroll-y', `${scrollY}px`);
                document.body.classList.add('modal--open');
            });

            this.changeEmailDialog.on('hide', () => {
                const scrollY = parseInt(document.body.style.getPropertyValue('--scroll-y') || '0');
                document.body.classList.remove('modal--open');
                window.scrollTo(0, scrollY);
            });
        }

        this.changeEmailDialog.show();
    },
    async saveUserProfileInfo() {
        this.errors = {};
        const form = document.getElementById('profile-info');
        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }

        const payload = {
            Prefix: this.prefix,
            FirstName: this.firstname,
            LastName: this.lastname,
        };
        const response = await API.PUT.updateProfile(this.csrfToken, payload);

        if (!response.ok) {
            const errorData = await response.json();
            this.errors = errorData;
            return;
        }
        if (response.ok) {
            const data = await response.json();
            window.accountDetails = data.account_details
            alert("Profile updated successfully!");
        }
    },
    async changeEmail(e) {
        this.errors = {};
        const form = e.target.closest('form')
        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }
        if (this.primaryEmail === this.currentEmail) {
            this.errors.primaryEmail = 'Please enter a new email address';
            return;
        }

        const payload = {
            Email: this.primaryEmail !== this.currentEmail ? this.primaryEmail : undefined,
        };
        const response = await API.PUT.updateProfile(this.csrfToken, payload);

        if (!response.ok) {
            const errorData = await response.json();
            this.errors = errorData;
            return;
        }
        if (response.ok) {
            const data = await response.json();
            this.currentEmail = this.primaryEmail
            this.primaryEmail = ''
            window.accountDetails = data.account_details
            this.changeEmailDialog.hide();
            alert("Email updated successfully!");
        }
    },
    async changePassword(e) {
        this.errors = {};
        const target = e.target;
        const form = target.closest('form');
        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }

        if (this.newPassword !== this.confirmPassword) {
            this.errors.confirmPassword = 'Passwords do not match';
            return;
        }

        const payload = {
            Password: this.currentPassword,
            NewPassword: this.newPassword,
        };

        const response = await API.PUT.updatePassword(this.csrfToken, payload)
        if (!response.ok) {
            const errorData = await response.json();
            this.errors = errorData;
            return;
        }
        if (response.ok) {
            alert("Password changed successfully!");
            this.currentPassword = '';
            this.newPassword = '';
            this.confirmPassword = '';
        }

    },
    passwordHint: passwordHint,
});
